// extracted by mini-css-extract-plugin
module.exports = {"searchLink":"SearchLink-module--searchLink--2IShR"};